var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrande(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6797_16312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6797_16312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41667 28C6.68333 28 6.05556 27.7389 5.53333 27.2167C5.01111 26.6944 4.75 26.0667 4.75 25.3333V12C4.75 11.2667 5.01111 10.6389 5.53333 10.1167C6.05556 9.59444 6.68333 9.33333 7.41667 9.33333H10.0833V6.66667C10.0833 5.93333 10.3444 5.30556 10.8667 4.78333C11.3889 4.26111 12.0167 4 12.75 4H20.75C21.4833 4 22.1111 4.26111 22.6333 4.78333C23.1556 5.30556 23.4167 5.93333 23.4167 6.66667V14.6667H26.0833C26.8167 14.6667 27.4444 14.9278 27.9667 15.45C28.4889 15.9722 28.75 16.6 28.75 17.3333V25.3333C28.75 26.0667 28.4889 26.6944 27.9667 27.2167C27.4444 27.7389 26.8167 28 26.0833 28H18.0833V22.6667H15.4167V28H7.41667ZM7.41667 25.3333H10.0833V22.6667H7.41667V25.3333ZM7.41667 20H10.0833V17.3333H7.41667V20ZM7.41667 14.6667H10.0833V12H7.41667V14.6667ZM12.75 20H15.4167V17.3333H12.75V20ZM12.75 14.6667H15.4167V12H12.75V14.6667ZM12.75 9.33333H15.4167V6.66667H12.75V9.33333ZM18.0833 20H20.75V17.3333H18.0833V20ZM18.0833 14.6667H20.75V12H18.0833V14.6667ZM18.0833 9.33333H20.75V6.66667H18.0833V9.33333ZM23.4167 25.3333H26.0833V22.6667H23.4167V25.3333ZM23.4167 20H26.0833V17.3333H23.4167V20Z",
    fill: "#D3135A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrande);
export default __webpack_public_path__ + "static/media/grande.ab1c383a26e6a4ea503ab2546b9c07d6.svg";
export { ForwardRef as ReactComponent };